<template>
<div>
    <div class="brand-panel">
        <div class="brand-name">{{ brandName }} {{ phonemodel }}</div>
        <div class="price-class">
        <span class="price-title">预估价</span>
        <span class="price" v-if="price">￥{{ price }}</span>
        <span class="price" style="margin-left:10px" v-else>选择选项后获取报价</span>
        </div>
    </div>

    <div class="chunk" v-if="!showOrderTag && orderItemTagList.length > 0">
        <div class="chunk-b">
            <orderItemTag :orderTagList="orderItemTagList" @select="onSelectItemTag"></orderItemTag>
        </div>
    </div>

    <div class="chunk" v-if="!showOrderTag && orderConditionTagList.length > 0">
      <div class="chunk-b">
        <orderConditionTag :orderTagList="orderConditionTagList" @select="onSelectConditionTag" ></orderConditionTag>
      </div>
    </div>

    <div class="chunk" v-if="!showOrderTag && orderFunctionTagList.length > 0">
      <div class="chunk-b">
        <orderFunctionTag :orderTagList="orderFunctionTagList" @select="onSelectFunctionTag" ></orderFunctionTag>
      </div>
    </div>

    <div class="chunk" v-if="showOrderTag">
      <div class="chunk-b">
        <orderTag :orderTagList="orderTagList" @select="onSelectTag" ></orderTag>
      </div>
    </div>

</div>
</template>
<script>
import { ITEM_OPTIONS } from '../../const/item-options'
import { Message } from 'element-ui'
export default {
  components: {  },
    data(){
        return{
            isHideReport: true,
            photoList: {},
            imeiValue: null,
            phonemodel: null,
            brandName: null,
            modeId: null,
            previewList: [],
            orderTagList: [],
            orderItemTagList:[],
            orderConditionTagList:[],
            orderFunctionTagList:[],
            needYCY: false,
            needFace: false,
            showOrderTag: false,
            categoryId:"",
            brandId:"",
            price:""
        }
    },

    async created() {

        const { showOrderTag } = false;
        this.phonemodel = this.$route.query.phonemodel;
        this.modelId = this.$route.query.modelId;
        this.showOrderTag = false;

        if (showOrderTag) {
            this.getOrderTag();
        }
        this.onShow();

    },

    methods: {
        async getOrderTag() {
            try {

            this.$api.getLinkAgeTree({
                    typeKey: "order_tag"
                })
                .then((res) => {
                const result = res.data;
                if (result && result.length) {
                    result.forEach(item => {
                    item.children[0].selected = true;
                    });

                    this.orderTagList = result;
                }
                });

            } catch (error) {
                console.error(error);
            }
        },

        onShow() {
            if (this.$app.model) {
                const {
                    name,
                    id,
                    ycy = 0,
                    face = 0,
                    disableQuotes = 0,
                    brandName,
                    brandId,
                    categoryId
                } = this.$app.model;
                this.phonemodel = name;
                this.modelId = id;
                this.needYCY = ycy;
                this.needFace = face;
                this.brandName = brandName;
                this.showOrderTag = false;
                this.brandId = brandId;
                this.categoryId = categoryId;
                this.getOrderTagByModelId(id);
                // delete this.$app.model;
                // this.$app.model = undefined;
            }
        },
        async getOrderTagByModelId(modelId) {
            try {
                if (this.showOrderTag) {
                    await this.getOrderTag();
                    return;
                }
                //Message("测试message");

                this.$api.getPriceQueryParamSearchPriceH5({
                        channelId:this.$route.query.channelId,
                        modelId: modelId,
                    }).then((res) => {
                        const result = res.data;
   
                        console.log('normal create order priceQueryParam response->', result);

                        if (result) {
                                const orderItemTagList = [];
                                ITEM_OPTIONS.forEach(item => {
                                    const itemTemp = {
                                    id: null,
                                    name: null,
                                    multipleChoice: null,
                                    selected: false,
                                    children: []
                                    };
                                    itemTemp.id = item.id;
                                    itemTemp.name = item.name;
                                    itemTemp.multipleChoice = item.multipleChoice;
                                    itemTemp.selected = false;

                                    if (item.id === 'sku_memory') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuMemory;
                                    } else if (item.id === 'sku_purchase_channel') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuPurchaseChannel;
                                    } else if (item.id === 'sku_body_color') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuBodyColor;
                                    } else if (item.id === 'sku_warranty_duration') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuWarrantyDuration;
                                    } else if (item.id === 'sku_small_model') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuSmallModel;
                                    } else if (item.id === 'sku_network') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuNetwork;
                                    } else if (item.id === 'sku_cpu') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuCpu;
                                    } else if (item.id === 'sku_graphics_card') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuGraphicsCard;
                                    } else if (item.id === 'sku_solid_drive') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuSolidDrive;
                                    } else if (item.id === 'sku_mechanical_drive') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuMechanicalDrive;
                                    }else if (item.id === 'sku_charging_interface') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuChargingInterface;
                                    }else if (item.id === 'sku_charging_method') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuChargingMethod;
                                    }else if (item.id === 'sku_case_size') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuCaseSize;
                                    }else if (item.id === 'sku_case_material') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuCaseMaterial;
                                    }else if (item.id === 'sku_watch_strap') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuWatchStrap;
                                    }else if (item.id === 'sku_strap_color') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuStrapColor;
                                    }else if (item.id === 'sku_left_right_ear') {
                                    itemTemp.children = result.brandSkuTreeDTO.skuLeftRightEar;
                                    }else if (item.id === "sku_external_keyboard") {
                                    itemTemp.children = this.brandSkuTreeDTO.skuExternalKeyboard;
                                    }else if (item.id === "sku_accessories_situation") {
                                    itemTemp.children = this.brandSkuTreeDTO.skuAccessoriesSituation;
                                    }

                                    if (itemTemp.children != null && itemTemp.children.length > 0) {
                                    itemTemp.children.forEach(e => {
                                        e.selected = false;
                                    });
                                    orderItemTagList.push(itemTemp);
                                    }
                            });

                            const conditionValues = [];
                            if (result.conditionValues != null && result.conditionValues.length > 0) {
                                result.conditionValues.forEach((item, index) => {
                                if (item.children != null && item.children.length > 0) {
                                    conditionValues.push(item);
                                }
                                });
                            }

                            const functionValues = [];
                            if (result.functionValues != null && result.functionValues.length > 0) {
                                result.functionValues.forEach((item, index) => {
                                if (item.children != null && item.children.length > 0) {
                                    functionValues.push(item);
                                }
                                });
                            }

                            conditionValues.forEach(e => {
                                e.selected = false;
                                e.children.forEach(e1 => {
                                if (e1.isGood === 1) {
                                    e1.selected = true;
                                    e.selected = true;
                                } else {
                                    e1.selected = false;
                                }
                                });
                            });

                            orderItemTagList.forEach(e => {
                                e.selected = false;
                                e.children.forEach((e1, index) => {
                                if (index === 0) {
                                    e1.selected = true;
                                    e.selected = true;
                                } else {
                                    e1.selected = false;
                                }
                                });
                            });

                            functionValues.forEach(e => {
                                e.selected = false;
                                e.children.forEach(e1 => {
                                e1.selected = false;
                                });
                            });

                            this.orderItemTagList = this.orderItemTagList.length ? this.orderItemTagList : orderItemTagList;
                            this.orderConditionTagList = this.orderConditionTagList.length ? this.orderConditionTagList : conditionValues;
                            this.orderFunctionTagList = this.orderFunctionTagList.length ? this.orderFunctionTagList : functionValues;

                            this.getPrice();
                        } else {
                            Message("获取机型信息失败，请重新操作");
                        }
                    
                    });


                
            } catch (error) {
                console.error(error);
            }
        },
        onSelectItemTag(event) {
            const { id } = event
            const { orderItemTagList } = this
            orderItemTagList.forEach(item => {
                const { children = [] } = item
                if (id) {
                    children.forEach(tag => {
                    if (tag.id === id) {
                        children.forEach(temp => {
                        temp.selected = false
                    })
                        tag.selected = true
                    }
                    })
                } else {
                    children.forEach(temp => {
                    temp.selected = false
                    })
                    children[0].selected = true
                }
                item.selected = false
                children.forEach(temp => {
                    if (temp.selected) {
                        item.selected = true
                    }
                })
            })
            this.orderItemTagList = [...orderItemTagList]
            this.getPrice()
        },
        onSelectConditionTag(event) {
            const { id } = event;
            const { orderConditionTagList } = this;
            
            orderConditionTagList.forEach(item => {
                const { children = [] } = item;
                
                if (id) {
                if (item.multipleChoice === 2) {
                    // 多选
                    const tag = children.find(tag => tag.id === id);
                    if (tag) {
                    tag.selected = !tag.selected;
                    }
                } else {
                    children.forEach(tag => {
                    if (tag.id === id) {
                        children.forEach(temp => {
                        temp.selected = false;
                        });
                        tag.selected = true;
                    }
                    });
                }
                } else {
                children.forEach(temp => {
                    if (temp.isGood === 1) {
                    temp.selected = true;
                    } else {
                    temp.selected = false;
                    }
                });
                }
                
                item.selected = false;
                children.forEach(temp => {
                if (temp.selected) {
                    item.selected = true;
                }
                });
            });
            
            this.getPrice();
        },
        onSelectFunctionTag(event) {
            const { id } = event
            const { orderFunctionTagList } = this
            orderFunctionTagList.forEach(item => {
                const { children = [] } = item
                if (id) {
                    if(item.multipleChoice===2){
                    for(let i=0;i<children.length;i++){
                        let tag = children[i];
                        if(children[i].id===id){
                            tag.selected=!tag.selected;
                            break;
                        }
                    } 
                    }else{
                        children.forEach(tag => {
                            if (tag.id == id) {
                                children.forEach(temp => {
                                    temp.selected = false
                                })
                                tag.selected = true
                            }
                        })
                    }
                } else {
                    children.forEach(temp => {
                        if(temp.isGood===1){
                            temp.selected = true;
                        }else{
                            temp.selected = false;
                        }
                    })
                }

                item.selected = false;
                children.forEach(temp=>{
                    if(temp.selected){
                        item.selected = true;
                    }
                });
            })
            this.orderFunctionTagList = orderFunctionTagList

            this.getPrice()
        },
        onSelectTag(event) {
            const { id } = event
            const { orderTagList } = this
            orderTagList.forEach(item => {
                const { children = [] } = item
                if (id) {
                    children.forEach(tag => {
                        if (tag.id == id) {
                            children.forEach(temp => {
                                temp.selected = false
                            })
                            tag.selected = true
                        }
                    })
                } else {
                    children.forEach(temp => {
                        temp.selected = false
                    })
                    children[0].selected = true
                }
            })
            this.orderTagList = orderTagList
        },
        async getPrice() {
            const data = {
                modelId: this.modelId,
                brandId: this.brandId,
                categoryId: this.categoryId,
                //userId: wx.getStorageSync('user').id,
            };

            if (this.orderItemTagList) {
                const itemTemplateValueByBrand = {};
                this.orderItemTagList.forEach(item => {
                if (item.id === 'sku_memory') {
                    itemTemplateValueByBrand.skuMemory = item.children;
                } else if (item.id === 'sku_purchase_channel') {
                    itemTemplateValueByBrand.skuPurchaseChannel = item.children;
                } else if (item.id === 'sku_body_color') {
                    itemTemplateValueByBrand.skuBodyColor = item.children;
                } else if (item.id === 'sku_warranty_duration') {
                    itemTemplateValueByBrand.skuWarrantyDuration = item.children;
                } else if (item.id === 'sku_small_model') {
                    itemTemplateValueByBrand.skuSmallModel = item.children;
                } else if (item.id === 'sku_network') {
                    itemTemplateValueByBrand.skuNetwork = item.children;
                } else if (item.id === 'sku_cpu') {
                    itemTemplateValueByBrand.skuCpu = item.children;
                } else if (item.id === 'sku_graphics_card') {
                    itemTemplateValueByBrand.skuGraphicsCard = item.children;
                } else if (item.id === 'sku_solid_drive') {
                    itemTemplateValueByBrand.skuSolidDrive = item.children;
                } else if (item.id === 'sku_mechanical_drive') {
                    itemTemplateValueByBrand.skuMechanicalDrive = item.children;
                }else if (item.id === "sku_charging_interface") {
                this.itemTemplateValueByBrand.skuChargingInterface = item.children;
                }else if (item.id === "sku_charging_method") {
                this.itemTemplateValueByBrand.skuChargingMethod= item.children;
                }else if (item.id === "sku_case_size") {
                this.itemTemplateValueByBrand.skuCaseSize= item.children;
                }else if (item.id === "sku_case_material") {
                this.itemTemplateValueByBrand.skuCaseMaterial= item.children;
                }else if (item.id === "sku_watch_strap") {
                this.itemTemplateValueByBrand.skuWatchStrap= item.children;
                }else if (item.id === "sku_strap_color") {
                this.itemTemplateValueByBrand.skuStrapColor= item.children;
                }else if (item.id === "sku_left_right_ear") {
                this.itemTemplateValueByBrand.skuLeftRightEar= item.children;
                }else if (item.id === "sku_external_keyboard") {
                this.itemTemplateValueByBrand.skuExternalKeyboard= item.children;
                }else if (item.id === "sku_accessories_situation") {
                this.itemTemplateValueByBrand.skuAccessoriesSituation= item.children;
                }
                });

                if (this.orderItemTagList.length > 0) {
                itemTemplateValueByBrand.phoneModel = null;
                }

                data.modelParam = JSON.stringify(itemTemplateValueByBrand);
            }
            data.conditionParam = JSON.stringify(this.orderConditionTagList);
            data.functionParam = JSON.stringify(this.orderFunctionTagList);
            data.channelId = this.$route.query.channelId;

            this.$api.priceQuerySearchPriceH5(data).then((res) => {
                if (res.code === 200) {
                this.price = res.data.price || {};
                }else{
                    this.price = "";    
                }
            });
        },

        
    },
    



}

</script>
<style lang="less" scoped>


.page {
background-color: #fff;
}

.container {
padding: 0 1rem;
padding-bottom: 1rem;
}

.rows {
border-bottom: 0.0333rem #e1e1e1 solid;
padding: 1rem 0;
display: flex;
justify-content: space-between;
align-items: center;
color: #333;
}

.rows-content {
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
}

.input-area {
text-align: right;
width: 10.33rem;
color: #333;
font-weight: 300;
}

.scan-btn {
width: 1.333rem;
padding-left: 0.333rem;
color: #ffffff;
}

.inputPlaceholder {
text-align: right;
color: #333;
font-weight: 300;
}

.tips {
padding: 1rem 0;
line-height: 2rem;
height: 2rem;
}

.row .rows-tips{
font-size: 0.8rem;
font-family: PingFang SC;
font-weight: 400;
line-height: 1.5333rem;
color: #171819;
}

.sign1 {
padding-right: 0.4rem;
font-size: 1rem;
font-family: Source Han Sans CN;
font-weight: 500;
line-height: 1.5333rem;
color: #171819;
}

.sign2 {
display: inline-block;
font-size: 0.8rem;
font-family: PingFang SC;
font-weight: 400;
line-height: 1.5333rem;
color: #C1C1C1;
}

.mark view {
font-size: 1rem;
}

.uploads {
width: 23rem;
display: flex;
flex-wrap: wrap;
}

.image-uploads-item {
margin-right: 2.9333rem;
}

.image-uploads-item:nth-child(3n) {
margin-right: 0;
}

/* .uploads .uploads-item:nth-child(3) {
padding-bottom: 1rem;
} */

.hidden-more {
display:flex;
justify-content: center;
align-items: center;
background-color: white;
padding: 1rem;
}

.health-info-icon {
width: 0.666rem;
height: 0.666rem;
margin-left: 0.333rem;
padding: 0.5rem;
}

.remark-tips {
padding-top: 1.2rem;
padding-bottom: 0.666rem;
/* text-indent: 0.666rem; */
font-size: 1rem;
font-family: Source Han Sans CN;
font-weight: 500;
line-height: 1.5333rem;
color: #171819;
}

.remark-text {
width: 23rem;
border: 0.0333rem dashed #999;
border-radius: 0.666rem;
color: #999;
font-size: 0.8rem;
padding-top: 0rem;
}

.remark textarea {
margin: 0 auto;
width: 21.6667rem;
height: 6.6667rem;
font-size: 0.8rem;
padding-top: 0.333rem;
}

.form-btn {
width: 16.6667rem;
background-color: #366ffe;
color: #fff;
padding: 1rem 0;
border-radius: 1.6667rem;
font-size: 1rem;
box-shadow: 0px 0.1667rem 0.6rem 0px rgba(54, 111, 254, 0.43);
}

.price {
font-size: 1.2rem;
font-family: PingFang SC;
font-weight: 800;
line-height: 1.5333rem;
color: #356FFA;
}

.tip{

}
.price-title {
font-size: 0.8rem;
font-family: PingFang SC;
font-weight: 400;
line-height: 1.5333rem;
color: #8B8B8B;
}

.brand-name{
    margin-top: 1rem;
    margin-bottom: 0.333rem;
    font-size: 0.8rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 1.5333rem;
    color: #171819;
}

.chunk {
padding: 0 1rem;
background-color: #fff;
}

.chunk-b {
padding-bottom: 0rem;
}

.brand-panel {
padding-bottom: 10rem;
border-bottom: 0.6667rem solid #f1f1f1;
padding: 0rem 1rem 1rem 1rem;
}



</style>